import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import API from "../../api"
const {projectSliderList,projectSliderAdd,projectSliderUpdate,projectSliderDelete,projectSliderEdit}=API

const initialState = { 
    data:[],
    singleProjectSlider:[],
    error: null, 
    loading:false,
    message:'',
    deleteLoad:false,
    editData:[]
}

const projectSliderSlice = createSlice({
    name: "projectSlider",
    initialState,
    reducers: {
      setData(state,action){
          state.data=action.payload;
      },
      setLoading(state, action) {
          state.loading = action.payload;
        },
      setMessage(state,action){
          state.message=action.payload;
      },
      setError(state,action){
          state.error=action.payload;
    },
      setDeleteLoad(state,action){
          state.deleteLoad=action.payload
      },
      setAfterDeleteProjectSlider(state,action){
          state.data=state.data.filter((item)=>item._id !== action.payload)
      },
      setProjectSliderAdd(state,action){
          state.data=[action.payload,...state.data]
      },
      setEditProjectSlider(state,action){
          state.singleProjectSlider=state.data.filter((item)=>item._id === action.payload)
      },
      setBlankSingleData(state,action){
        state.singleProjectSlider=[]
      },
      setEditData(state,action){
        state.editData=action.payload
    }
    },
  });
  
  export const {setEditData, setLoading, setMessage,setError,setData,setDeleteLoad,setProjectSliderAdd,setAfterDeleteProjectSlider,setEditProjectSlider,setBlankSingleData} = projectSliderSlice.actions;
  export default projectSliderSlice.reducer;

  export const getProjectSliderData = () => async (dispatch) => {
         dispatch(setLoading(true));
    try {
      const res= await projectSliderList()
      if (res.data.success) {
          dispatch(setData(res.data.data[0]?.fieldvalue))
          dispatch(setLoading(false));
          dispatch(setMessage(res.data.message))
      } else {
          dispatch(setLoading(false));
          dispatch(setError(res.data.message));
      }
    } catch (e){
      dispatch(setLoading(false));
      dispatch(setError(e.message));
      message.error(e.message);
    }
  };
  export const projectSliderDataAdded=(data) => async (dispatch)=>{
    dispatch(setDeleteLoad(true));
    try{
      const res= await projectSliderAdd(data)
      if(res.data.success) {
         dispatch(setProjectSliderAdd(data))
         dispatch(setDeleteLoad(false))
         dispatch(setMessage(res.data.message))
         message.success(res.data?.message);
      } else {
        dispatch(setDeleteLoad(false));
        dispatch(setError(res.data.message));
        message.error(res.data.message);
    }
    } catch(e){
      dispatch(setDeleteLoad(false));
      dispatch(setError(e.response.data.message));
      message.error(e.response.data.message);
    }
}

export const sigleProjectSliderDataAction=(id) =>(dispatch)=>{
              dispatch(setEditProjectSlider(id))
}
export const blankDataAction=() =>(dispatch)=>{
  dispatch(setBlankSingleData())
}
export const projectSliderDataUpdate=(id,data) => async (dispatch)=>{
  dispatch(setDeleteLoad(true));
  try{
    const res= await projectSliderUpdate(id,data)
    if(res.data.success) {
       dispatch(setBlankSingleData())
       dispatch(setEditData())
       dispatch(setDeleteLoad(false))
       dispatch(setMessage(res.data.message))
       message.success(res.data?.message);
    } else {
      dispatch(setDeleteLoad(false));
      dispatch(setError(res.data.message));
      message.error(res.data.message);
  }
  } catch(e){
    dispatch(setDeleteLoad(false));
    dispatch(setError(e.response.data.message));
    message.error(e.response.data.message);
  }
}
export const projectSliderEditAction=(id,field) => async (dispatch)=>{
  try{
    const res= await projectSliderEdit(id,field)
    if(res.data.success) {
       dispatch(setEditData(res.data.data))
    } else {
      message.error(res.data.message);
  }
  } catch(e){
    message.error(e.response.data.message);
  }
}
export const editBlankData=() =>(dispatch)=>{
        dispatch(setEditData())
}
  export const projectSliderDataDelete=(id) => async (dispatch)=>{
          dispatch(setDeleteLoad(true));
          try{
            const res= await projectSliderDelete(id)
            if(res.data.success) {
               dispatch(setAfterDeleteProjectSlider(id))
               dispatch(setDeleteLoad(false))
               dispatch(setMessage(res.data.message))
               message.success(res.data?.message);
            } else {
              dispatch(setDeleteLoad(false));
              dispatch(setError(res.data.message));
              message.error(res.data.message);
          }
          } catch(e){
            dispatch(setDeleteLoad(false));
            dispatch(setError(e.response.data.message));
            message.error(e.response.data.message);
          }
  }